<script setup lang="ts">
import { useTimeoutPoll, useTimestamp } from '@vueuse/core';

const props = defineProps<{
    endTimeList?: SESSION_API.QuerySessionCountdownToEndRes[];
    groupId?: string;
    avatar?: string;
    isCompetitionType?: boolean;
}>();

const seconds = ref(0);
const closeDuration = ref(0);
const timestamp = useTimestamp({ interval: 1000 });
const { pause, resume } = useTimeoutPoll(updateSeconds, 1000);

const endTimeTimestamp = computed(() => {
    return timestamp.value + seconds.value * 1000;
});

const isShowProgress = computed(() => {
    return seconds.value > 0 && endTimeTimestamp.value > timestamp.value;
});

const strokeColor = computed(() => {
    if (percent.value < 15) {
        return '#D95145';
    }

    if (percent.value < 50) {
        return '#E6842A';
    }

    return '#5CB03F';
});

const title = computed(() => {
    if (!seconds.value) {
        return '';
    }
    const sec = seconds.value % 60;
    const minutes = Math.floor(seconds.value / 60);

    return `剩余时间：${minutes < 10 ? '0' + minutes : minutes}:${sec < 10 ? '0' + sec : sec}`;
});

const percent = computed(() => {
    return ((seconds.value * 1000) / (Math.abs(closeDuration.value) * 1000)) * 100;
});

function updateSeconds() {
    seconds.value = seconds.value - 1;

    if (seconds.value <= 0) {
        pause();
    } else {
        resume();
    }
}

watch(
    () => props.endTimeList,
    newVal => {
        seconds.value = newVal?.find(item => item.groupId === props.groupId)?.leftSeconds ?? 0;
        closeDuration.value =
            newVal?.find(item => item.groupId === props.groupId)?.closeDuration ?? 20 * 60;
        resume();
    },
    { immediate: true, deep: true }
);
</script>

<template>
    <div class="relative w-46px h-46px flex-center">
        <a-tooltip :title="title">
            <a-progress
                v-if="isShowProgress"
                type="circle"
                :show-info="false"
                :stroke-width="6"
                :size="46"
                :stroke-color="strokeColor"
                :percent="percent"
                class="absolute top-0 left-0"
            />
            <div>
                <a-avatar
                    :src="avatar"
                    :size="isShowProgress ? 42 : 46"
                ></a-avatar>
            </div>

            <div
                v-if="isCompetitionType"
                class="absolute -bottom-2px left-50% translate-x-[-50%] color-#8c5af0 bg-#fff border-solid border-#8c5af0 border-1px rounded-4px text-center w-40px text-10px h-4"
                flex="~ center"
            >
                三创赛
            </div>
        </a-tooltip>
    </div>
</template>
